export const tipoOuvidoriaFormatEnum = {
  ANONIMO: 'Anônimo',
  COM_RESTRICAO_DADOS: 'Com restrição de dados',
  SEM_RESTRICAO_DADOS: 'Sem restrição de dados'
};
